import { Navigate, useRoutes } from "react-router-dom";
import LoginPage from "./pages/back-office/login";
import HomeScreen from "./pages/home";
import ResetPasswordPage from "./pages/back-office/reset-password";
import ForgotPasswordPage from "./pages/back-office/forgot-password";
import { EventDetails } from "./pages/event-details";
import { Checkout } from "./pages/checkout";
import CheckoutSuccessPage from "./pages/checkout-summary";
import TermsAndCondition from "./pages/terms-condition/terms";
import PrivacyAndPolicy from "./pages/privacy-policy";
import ContactUs from "./pages/contact-page";
import SignUp from "./pages/back-office/signup";

export default function LoginRoutes() {
  const loginRoutes = useRoutes([
    {
      path: "*",
      element: <HomeScreen />,
      index: true,
    },

    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "signup",
      element: <SignUp />,
    },
    {
      path: "forgotpassword",
      element: <ForgotPasswordPage />,
    },
    {
      path: "reset-password",
      element: <ResetPasswordPage />,
    },
    {
      path: "*",
      element: <Navigate to="/home" replace />,
    },
    {
      path: "event/:eventName",
      element: <EventDetails />,
    },
    { path: "checkout", element: <Checkout /> },
    { path: "contact-us", element: <ContactUs /> },
    { path: "checkout-successful", element: <CheckoutSuccessPage /> },
    { path: "checkout-successful/:id", element: <CheckoutSuccessPage /> },
    { path: "terms-and-condition", element: <TermsAndCondition /> },
    { path: "privacy-and-policy", element: <PrivacyAndPolicy /> },
  ]);

  return loginRoutes;
}
